import React, { Component, PropTypes } from 'react';
import ModalHeader from 'components/Modal/ModalHeader';
import classNames from 'classnames';

export default class Modal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    width:PropTypes.string,
    headerComponent: PropTypes.node,
    contentComponent: PropTypes.node,
    footerComponent: PropTypes.node,
    disableScroll: PropTypes.bool,
  };

  render() {
    const { open, width, headerComponent, contentComponent, footerComponent, disableScroll } = this.props;

    return open ?
      <div className={classNames('modal', disableScroll ? 'disable-scroll' : '', { open })}>
        <div className={classNames('modal-body', width)}>
          <div className='modal-header'>
            {headerComponent || null}
          </div>
          <div className='modal-content'>
            {contentComponent || null}
          </div>
          <div className='modal-footer'>
            {footerComponent || null}
          </div>
        </div>
      </div>
      : null;
  }
}

export { ModalHeader };
